import { render, staticRenderFns } from "./StudentMapShell.vue?vue&type=template&id=951fdb9c"
import script from "./StudentMapShell.vue?vue&type=script&lang=js"
export * from "./StudentMapShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports